import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { constant } from 'app/app.constants';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IActiveTripsProviders } from 'app/core/interfaces/active-trips-providers.interface';
import { SignalRService } from 'app/core/services/signal-r.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { TripNotificationsService } from 'app/services/trip-notifications.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-t2-badge-providers',
  templateUrl: './t2-badge-providers.component.html',
  styleUrls: ['./t2-badge-providers.component.scss'],
})
export class T2BadgeProvidersComponent extends ParentModule implements OnInit, OnDestroy {
  showBadge = true;
  activeTrips: Array<IActiveTripsProviders> = [];
  private lastUpdateActiveTrips: Array<IActiveTripsProviders> = [];
  private subscriptions: Array<Subscription> = [];
  private todaysTripsRoute = '/pages/dispatch/providerDispatch';
  private tripsHubConnection = 'ActiveTrips';

  constructor(
    protected inject: Injector,
    private signalRService: SignalRService,
    private tripService: ReservationService,
    private sweatAlertService: SweetAlertHelper,
    private tripNotificationsService: TripNotificationsService,
    private router: Router
  ) {
    super('app-today-trips-dispatch', inject);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.actionsList$.subscribe((resp) => {
        this.showBadge = resp.includes('ShowActiveTripsCount');
        if (this.showBadge) {
          this.startSignalR();
          this.tripNotificationsService.requestPermission();
          this.getActiveTrips();
        }
      }),
      this.tripNotificationsService.companyIdTodaysTrips$.subscribe(
        (companyId: number) => {
          if (companyId) {
            this.updateTodaysTrips(companyId);
          }
        }
      ),
    );
  }

  providerChanged(companyId: number, activeTrips: number): boolean {
    if (!this.lastUpdateActiveTrips) {
      return true;
    }

    return this.lastUpdateActiveTrips.some(
      (lastTrip: IActiveTripsProviders) =>
        lastTrip.companyid === companyId && lastTrip.activetrips === activeTrips
    );
  }

  private getActiveTrips(afterSignal: boolean = false): void {
    this.subscriptions.push(
      this.tripService.getActiveTrips().subscribe(
        (resp) => {
          this.activeTrips = resp;
          if (!afterSignal) {
            this.lastUpdateActiveTrips = resp;
          } else {
            this.compareActiveTrips();
          }
        },
        (error) => {
          this.sweatAlertService.captureException(error);
          this.tripNotificationsService.closeSignalR();
        }
      )
    );
  }

  private goToTodaysTrips(companyId: number): void {
    if (companyId) {
      this.router.navigate([this.todaysTripsRoute]);
      this.tripNotificationsService.setCompanyIdTodaysTrips(Number(companyId));
      this.updateTodaysTrips(companyId);
    }
  }

  private startSignalR(): void {
    this.signalRService
      .start()
      .then((connection) => {
        this.tripNotificationsService.setConnection(connection);
        return this.signalRService
          .registerHubConnection(constant.URL_HUB_ACTIVE_TRIPS)
          .toPromise();
      })
      .then(() => {
        this.signalRService.subscribeTo(this.tripsHubConnection, (resp) => {
          if (resp) {
            this.getActiveTrips(true);
          }
        });
      });
  }

  private updateTodaysTrips(companyId: number): void {
    const current = this.activeTrips.find(c => c.companyid === companyId);
    const previous = this.lastUpdateActiveTrips.find(c => c.companyid === companyId);

    if (current && previous) {
      previous.activetrips = current.activetrips;
    }

    if (current && !previous) {
      this.lastUpdateActiveTrips.push(Object.assign({}, current));
    }
  }

  private compareActiveTrips(): void {
    this.activeTrips.map((trip: IActiveTripsProviders) => {
      const tripExists = this.lastUpdateActiveTrips.some(
        (lastTrip: IActiveTripsProviders) =>
          lastTrip.companyid === trip.companyid &&
          lastTrip.activetrips === trip.activetrips
      );

      if (!tripExists) {
        this.requestAndShowNotification(trip);
      }
    });
  }

  private requestAndShowNotification(activeTrip: IActiveTripsProviders): void {
    this.subscriptions.push(
      this.tripNotificationsService.notify(
        'New Active Trips',
        {
          body: `The provider ${activeTrip.speedcode} now has ${activeTrip.activetrips} active trips`,
          icon: 'assets/images/logo.png',
        }
      ).subscribe({
        next: () => {
          this.router.navigate([this.todaysTripsRoute]);
          this.tripNotificationsService.setCompanyIdTodaysTrips(activeTrip.companyid);
        },
        error: err => {
          this.sweatAlertService.captureException(err);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-badge-providers/t2-badge-providers.component.ts